module.exports = __webpack_public_path__ + "media/3.a0ea7978.wav";